import React from 'react';
import { Button } from '@itandi/itandi-bb-ui';
import { Table } from '~/components/common/parts/table/Table';
import { TableHeader } from '~/components/common/parts/table/TableHeader';
import { TableBody } from '~/components/common/parts/table/TableBody';
import { useVendorPartners } from '~/hooks/vendors/useVendorPartners';
import type { VendorPartner } from '~/models/VendorPartner';
import { VendorPartnerListRow } from '~/components/specifics/vendors/settings/vendor_partners/VendorPartnerListRow';
import Styles from './VendorPartnerList.module.scss';
import { VendorPartnerAddModal } from '~/components/specifics/vendors/settings/vendor_partners/VendorPartnerAddModal';
import { useOpenHandler } from '~/hooks/useOpenHandler';

export const VendorPartnerList: React.FC = () => {
  const { data: partners, mutate: mutatePartners } =
    useVendorPartners().index();
  const { isOpen, handleOpen, handleClose } = useOpenHandler();
  const renderRow = React.useCallback(
    (partner: VendorPartner) => (
      <VendorPartnerListRow key={partner.id} vendorPartner={partner} />
    ),
    []
  );
  const handleMutate = React.useCallback(async () => {
    await mutatePartners?.();
  }, [mutatePartners]);

  return (
    <div className={Styles.TableWrapper}>
      <Table>
        <TableHeader>
          <th>協力会社名</th>
          <th className={Styles.AllowChatCol}>チャット許可</th>
          <th className={Styles.OperationCol}>操作</th>
        </TableHeader>
        <TableBody>{partners?.map(renderRow)}</TableBody>
      </Table>
      <div className={Styles.ButtonArea}>
        <Button onClick={handleOpen} variant="secondary">
          協力会社の追加
        </Button>
      </div>
      <VendorPartnerAddModal
        handleClose={handleClose}
        handleMutate={handleMutate}
        isOpen={isOpen}
      />
    </div>
  );
};
